import { UNABLE_TO_INSERT_CSS } from "@/helpers/constants";
import { css } from "@/utils/css";

import type { Content } from "../types";

export async function injectCookiedockCSS(content: Content) {
  const style = await import("../style.scss?inline");

  try {
    const styleElement: HTMLStyleElement = document.createElement("style");
    styleElement.innerText = style.default;
    document.head.appendChild(styleElement);
    addStyles(styleElement, content);
  } catch (error) {
    console.error(error, UNABLE_TO_INSERT_CSS);
  }
}

function addStyles(el: HTMLStyleElement, content: Content) {
  const defaultPrimaryColor = "#0078d4";
  const defaultSecondaryColor = "#f3f2f1";

  const primaryColor = css.isValidHex(content.primary_color) ? content.primary_color : defaultPrimaryColor;
  const secondaryColor = css.isValidHex(content.secondary_color) ? content.secondary_color : defaultSecondaryColor;

  const textColor = css.isDarkColor(primaryColor) ? "#ffffff" : "#000000";
  const primaryIsDark = css.isDarkColor(primaryColor);
  const secondaryIsDark = css.isDarkColor(secondaryColor);

  css.addStylesheetRules(el, [
    // Banner/Container styles
    [".__cookiedock .__container", ["box-shadow", "0 4px 12px rgba(0, 0, 0, 0.15)", "true"]],
    [".__cookiedock .__container .__row .__col .--header::after", ["background-color", secondaryColor, "true"], ["height", "3px", "true"]],

    // Button styles
    [
      ".primary",
      ["background-color", primaryColor, "true"],
      ["border-color", primaryColor, "true"],
      ["color", textColor, "true"],
      ["border-radius", "4px", "true"],
      ["transition", "all 0.2s ease-in-out", "true"],
      ["box-shadow", "0 2px 4px " + css.hex2rgba(primaryColor, 0.3), "true"],
    ],
    [
      ".primary:hover",
      ["background-color", css.hex2rgba(primaryColor, 0.9), "true"],
      ["transform", "translateY(-1px)", "true"],
      ["box-shadow", "0 4px 8px " + css.hex2rgba(primaryColor, 0.4), "true"],
    ],
    [".secondary", ["color", secondaryColor, "true"], ["border-color", secondaryColor, "true"], ["border-radius", "4px", "true"], ["transition", "all 0.2s ease-in-out", "true"]],
    [".secondary:hover", ["background-color", css.hex2rgba(secondaryColor, 0.1), "true"]],

    [".__preferences--banner", ["transition", "all 0.15s ease-in-out", "true"]],
    [".__preferences--banner:checked", ["background-color", primaryColor, "true"], ["border", "2px solid " + primaryColor, "true"]],
    [".__cookiedock .__container .__row .__col .-radio-label", ["border-radius", "3px", "true"], ["transition", "background-color 0.15s ease-in-out", "true"]],
    [".__cookiedock .__container .__row .__col .-radio-label:hover:not([disabled])", ["background-color", css.lighten(primaryColor, 80), "true"], ["color", primaryColor, "true"]],

    // Dialog styles
    [".__cookiedock #__dialog", ["box-shadow", "0 10px 25px rgba(0, 0, 0, 0.2)", "true"]],
    [".__cookiedock #__dialog .__details", ["margin-bottom", "8px", "true"]],
    [".__cookiedock #__dialog .__details .--group", ["border-radius", "4px", "true"], ["transition", "all 0.15s ease-in-out", "true"]],
    [".__cookiedock #__dialog .__details .--group .-active::before", ["background-color", textColor, "true"], ["border-radius", "50%", "true"]],
    [
      ".__cookiedock #__dialog .__details .--group .-active",
      ["color", primaryIsDark ? "#ffffff" : primaryColor, "true"],
      ["background-color", secondaryColor, "true"],
      ["color", secondaryIsDark ? "#ffffff" : "#000000", "true"],
    ],
    [".__cookiedock #__dialog .__details .--group > .__preferences--dialog[open] > summary", ["background-color", primaryColor, "true"], ["color", textColor, "true"]],

    [".__cookiedock #__dialog .__details .__purposes-container", ["padding", "12px", "true"]],
    [".__cookiedock #__dialog .__details .__purposes-container .-details .-summary", ["transition", "background-color 0.15s ease-in-out", "true"]],
    [".__cookiedock #__dialog .__details .__purposes-container .-details .-summary:hover", ["background-color", css.lighten(primaryColor, 75), "true"]],
  ]);
}
